import { Flex, Box, Container, Center, Icon, Text } from "@chakra-ui/react";
import { useState } from "react";
import { TfiControlBackward } from "react-icons/tfi";
import { useNavigate } from "react-router-dom";

export default function HoldingPage() {
  const [isHovered, setIsHovered] = useState(false);
  const nav = useNavigate();

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };
  return (
    <Box w={"100vw"} bgColor={"#fdfbf5"} padding={"1rem"} height={"100vh"}>
      <Box border={"1px solid black"} height={"100%"}>
        <Container
          maxW={"1860px"}
          padding={{ base: "0 1rem", md: "0 2rem", lg: "0 3rem" }}
        >
          <Flex flexDir={"column"} gap={"1rem"}>
            <Flex
              width={"100%"}
              borderBottom={"1.5px solid black"}
              alignItems={"center"}
              padding={"32px 0"}
            >
              <Flex
                cursor={"pointer"}
                alignItems={"center"}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                onClick={() => nav("/")}
              >
                <Center fontSize={"3xl"}>
                  <Icon as={TfiControlBackward}></Icon>
                </Center>
                {isHovered ? <Text>Home</Text> : null}
              </Flex>
            </Flex>
            <Flex
              paddingBottom={"1rem"}
              flexDir={{ base: "column", lg: "row" }}
            >
              <Flex
                width={{ base: "100%", lg: "20%" }}
                borderRight={{ base: "none", lg: "1.5px solid black" }}
                display={"flex"}
                flexDir={"column"}
                gap={"0.5rem"}
                fontWeight={{ base: "bold", lg: "normal" }}
              >
                <Center
                  className="font-paragraph"
                  padding={"1rem"}
                  fontSize={"xl"}
                >
                  RESUME
                </Center>
              </Flex>

              <Flex
                padding={"1rem 2rem"}
                width={{ base: "100%", lg: "90%" }}
                flexWrap={"wrap"}
                alignItems={"center"}
                justifyContent={"center"}
                flexDir={"column"}
              >
                <Flex
                  borderBottom={{ base: "none", lg: "1.5px solid black" }}
                  padding={"1rem 0"}
                  flexDir={{ base: "column", lg: "row" }}
                >
                  Unavailable at the moment
                </Flex>
              </Flex>
            </Flex>
          </Flex>
        </Container>
      </Box>
    </Box>
  );
}
